import { ActionTypes as types } from '../constant';

export function startVideo(index) {
  return {
    type: types.START_VIDEO_PLAY,
    data: {
      videoIndex: index,
      playVideo: true,
      stopVideo: false,
    },
  };
}

export function stopVideo(index) {
  return {
    type: types.STOP_VIDEO_PLAY,
    data: {
      videoIndex: index,
      playVideo: false,
      stopVideo: true,
      // playVideo: !store.getState().carousel.playVideo // to toggle we get the state value
    },
  };
}

export function selectedCharity(selectedIndx, source) {
  return {
    type: types.CHARITY_SELECTED,
    data: {
      selectedIndx,
      source,
    },
  };
}

export function selectedCharityInfo(
  selectedIndexCharityInfo,
  source,
  charityResponse
) {
  return {
    type: types.CHARITY_INFO_SELECTED,
    data: {
      selectedIndexCharityInfo,
      source,
      charityResponse,
    },
  };
}

export function defaultPopoverState(source) {
  return {
    type: types.CLOSE_POPOVER,
    data: {
      source,
    },
  };
}

export function defaultState(source) {
  return {
    type: types.CHARITY_UNSELECTED,
    data: {
      source,
    },
  };
}

export function expandSeeMore(source) {
  return {
    type: types.SEE_MORE,
    data: {
      source,
    },
  };
}
